import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LoadingPage from "../../renderer/utils/LoadingPage";
import { surfaces } from "../../design-system/tokens";

const EditRedirectPage = () => {
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/edit/${username}`, { replace: true });
  }, [username, navigate]);

  return (
    <div className={`editor-theme min-h-screen ${surfaces.modernApp} flex flex-col`}>
      <LoadingPage />
    </div>
  );
};

export default EditRedirectPage; 